import { Epic, ofType } from 'redux-observable';
import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { actions } from '.';
import { addErrorNotice, callApi, catchWithAuthErrors } from 'Data/Helpers/rxjsHelpers';
import webApi from 'Lib/WebApi';
import { of } from 'rxjs';
import { IAgsExports, IAgsExport, IAgsExportRevision, IAgsExportSelectedProject } from 'Data/ViewModels/Ags';
import { IQApiResponse } from 'Data/ViewModels/Core/IQApiResponse';

export const init: Epic = (action$) =>
  action$.pipe(
    ofType(actions.init.toString()),
    mergeMap(({ payload: projectId }) =>
      callApi(webApi.ags.exports.query.get({ projectId })).pipe(
        mergeMap((response: IQApiResponse<IAgsExports>) => of(actions.initResolve(response.Body))),
        catchWithAuthErrors((err?: any) =>
          of(actions.initReject(), addErrorNotice('Failed to initialise Project.', err))
        )
      )
    )
  );

export const runNewExport: Epic = (action$, state$) =>
  action$.pipe(
    ofType(actions.runNewExport.toString()),
    withLatestFrom(state$),
    mergeMap(([{ payload: { startDate = null, endDate = null } }, { agsProjectExport: { projectId = null } }]) =>
      callApi(
        webApi.ags.exports.create.post({ Body: { ProjectId: projectId, StartDate: startDate, EndDate: endDate } }, {})
      ).pipe(
        mergeMap((response: IQApiResponse<IAgsExport>) => of(actions.runNewExportResolve(response.Body))),
        catchWithAuthErrors((err?: any) =>
          of(addErrorNotice('Failed to run new AGS Project Export.', err), actions.runNewExportReject())
        )
      )
    )
  );

export const reissueExport: Epic = (action$, state$) =>
  action$.pipe(
    ofType(actions.reissueExport.toString()),
    mergeMap(({ payload: agsExportId }) =>
      callApi(webApi.ags.exports.reissue.post({}, { agsExportId })).pipe(
        mergeMap((response: IQApiResponse<IAgsExportRevision>) => of(actions.reissueExportResolve(response.Body))),
        catchWithAuthErrors((err?: any) =>
          of(addErrorNotice('Failed to reissue AGS Project Export.', err), actions.reissueExportReject())
        )
      )
    )
  );

export const setAgsExportConfiguration: Epic = (action$, state$) =>
  action$.pipe(
    ofType(actions.setAgsExportConfiguration.toString()),
    mergeMap(({ payload: { configurationId, projectId } }) =>
      callApi(
        webApi.ags.exportConfiguration.project.patch(
          { Body: { AgsExportConfigurationUUID: configurationId } },
          { projectId: projectId }
        )
      ).pipe(
        mergeMap((response: IQApiResponse<IAgsExportSelectedProject>) =>
          of(actions.setAgsExportConfigurationResolve(response.Body))
        ),
        catchWithAuthErrors((err?: any) =>
          of(
            addErrorNotice('Failed to update AGS Export Configuration for Project.', err),
            actions.setAgsExportConfigurationReject()
          )
        )
      )
    )
  );
